<template>
  <div class="configurationList">
    <div class="configurationList_selectionArea">
      <div class="search_box">
        <el-input v-model="parameter.key_word" placeholder="请输入关键字" style="width: 200px; margin-right: 10px" />
        <el-select v-model="parameter.phone_id" placeholder="请选择手机" style="margin-right: 10px;">
          <el-option
            v-for="item in mobilePhones"
            :key="item.id"
            :label="item.phone_name"
            :value="item.id"
          />
        </el-select>
        <el-select v-model="parameter.customer_id" placeholder="请选择客服" style="margin-right: 10px;">
          <el-option
            v-for="item in customerServices"
            :key="item.id"
            :label="item.customer_name"
            :value="item.id"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="dialogVisible = true">创建</el-button>
      </div>
    </div>
    <div class="configurationList_main">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
          min-width="80"
          align="center"
        />
        <el-table-column
          prop="key_word"
          label="关键字"
          width="180"
          align="center"
        />
        <el-table-column
          prop="qrcode_img"
          label="二维码"
          width="180"
          align="center"
        >
          <template scope="scope">
            <el-popover
              placement="right"
              title="详情"
              width="280"
              trigger="hover"
            >
              <img :src="scope.row.qrcode_img" style="width: 250px">
              <img v-if="scope.row.qrcode_img" slot="reference" :src="scope.row.qrcode_img" style="width: 100px; height: 80px">
              <span v-else>暂无</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="客服名称"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="phone_vx_account"
          label="微信号"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="equipment_code"
          label="手机设备编码"
          min-width="180"
          align="center"
        />
        <el-table-column
          prop="phone_name"
          label="手机编号"
          min-width="120"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          min-width="120"
          align="center"
        >
          <template scope="scope">
            {{ timestampToTime(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updated_at"
          label="更新时间"
          min-width="120"
          align="center"
        >
          <template scope="scope">
            {{ timestampToTime(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作" min-width="180" align="center">
          <template scope="scope">
            <!-- <el-button type="primary" size="mini" @click="modifyItem(scope.row)">修改</el-button> -->
            <el-button type="primary" size="mini" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.total"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <el-dialog
      :title="currentItem ? '修改' : '创建'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <Details v-if="dialogVisible" @determine="determine" @close="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import Details from './components/details.vue'
import { configurationList, mobilePhoneList, enterpriseWeChatCustomerServiceList, configurationAdd, configurationDeletion } from '@/api/enterpriseWeChatCustomerService'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      parameter: {
        key_word: null,
        phone_id: null, // 手机
        customer_id: null, // 客服
        page: 1,
        pageSize: 10
      },
      tableData: {},
      loading: false,
      currentItem: {},
      dialogVisible: false,
      mobilePhones: [], // 手机列表
      customerServices: [] // 客服列表
    }
  },
  created() {
    this.getList()
    this.init()
  },
  methods: {

    async init() {
      const data = await mobilePhoneList()
      const data1 = await enterpriseWeChatCustomerServiceList()
      this.mobilePhones = data.data.list
      this.customerServices = data1.data.list
    },

    // 获取列表数据
    async getList() {
      this.loading = true
      const data = await configurationList(this.parameter)
      this.loading = false
      data.data.list = data.data.list.map((item) => { return { ...item, qrcode_img: `${data.data.qiniu_domain + item.qrcode_img}` } })
      this.tableData = data.data
    },

    // 删除
    async deleteItem(row) {
      this.$confirm('该删除将会影响到 错误列表 相关联的数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await configurationDeletion({ id: row.id })
        this.getList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },

    // 修改
    modifyItem(row) {

    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.getList()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.key_word = null
      this.parameter.phone_id = null
      this.parameter.customer_id = null
      this.getList()
    },

    // 确定
    async determine(form) {
      const bool = !!Object.keys(this.currentItem).length
      bool ? null : await configurationAdd(form)
      this.dialogVisible = false
      this.currentItem = {}
      this.getList()
      this.$message({
        message: bool ? '修改成' : '创建成功',
        type: 'success'
      })
    },

    handleClose(done) {
      this.dialogVisible = false
    },

    fetchPageSizeone(e) {
      this.parameter.pageSize = e
    },

    fetchCurrentPageone(e) {
      this.parameter.page = e
    },

    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000)// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds())
      return Y + M + D + h + m + s
    }
  }
}
</script>

<style scoped>
.configurationList{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}

.configurationList_selectionArea{
   display: flex;
   align-items: center;
   justify-content: space-between;
}

.configurationList_main{
   margin-top: 30px;
}
</style>
